module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Braven.4267d72.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Braven.jpg
// module id = R15t
// module chunks = 0